// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ting_lu: PokeData = {
  "id": 1003,
  "name": "ting-lu",
  "height": 27,
  "weight": 6997,
  "base_experience": 285,
  "types": [
    PokeType.DARK,
    PokeType.GROUND
  ],
  "api_moves": [
    "whirlwind",
    "stomp",
    "thrash",
    "earthquake",
    "fissure",
    "rock-slide",
    "spite",
    "spikes",
    "mean-look",
    "memento",
    "taunt",
    "sand-tomb",
    "payback",
    "dark-pulse",
    "bulldoze",
    "throat-chop",
    "stomping-tantrum",
    "ruination"
  ],
  "moves": [
    "earthquake",
    "fissure",
    "rock-slide",
    "dark-pulse",
    "mud-slap",
    "flatter",
    "bite",
    "bone-throw",
    "mud-bomb",
    "rototiller",
    "magnitude",
    "mud-shot",
    "phantom-force"
  ],
  "evolution_chain": {
    "id": 531,
    "item": null,
    "species": [
      {
        "name": "ting-lu",
        "order": 994,
        "types": [
          PokeType.DARK,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 181,
    "speed": 63,
    "ability_power": 155
  },
  "stat_changes": [],
  "catch_rate": 6,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
